import {List} from 'immutable';

import {ObservationVariant} from 'web-app/react/entities/observations/constants';

export const prepareAreaRefinementsForApi = formAreaRefinements => {
    if (formAreaRefinements) {
        return List(Object.keys(formAreaRefinements))
            .filter(parentAreaId => {
                const refinement = formAreaRefinements[parentAreaId];
                return (refinement.areaId && refinement.refinement) || refinement.note;
            })
            .map(parentAreaId => {
                const refinement = formAreaRefinements[parentAreaId];
                const returnValue = [];
                if (refinement.note) {
                    returnValue.push({
                        areaId: parentAreaId,
                        note: refinement.note,
                    });
                }
                if (refinement.areaId && refinement.refinement) {
                    returnValue.push({
                        areaId: refinement.areaId,
                        refinement: refinement.refinement,
                    });
                }
                return returnValue;
            })
            .flatMap(a => a)
            .toArray();
    }
    return null;
};

export const prepareAreaRefinementForForm = (variant, areaRefinements) => {
    switch (variant) {
        case ObservationVariant.ASSESSMENT:
        case ObservationVariant.TWO_YEAR_PROGRESS:
            return areaRefinements.reduce(
                (reduction, ref) =>
                    ref.note
                        ? {
                              ...reduction,
                              [ref.area.id]: {
                                  ...(reduction[ref.area.id] || {}),
                                  note: ref.note,
                              },
                          }
                        : {
                              ...reduction,
                              [ref.area.parentId]: {
                                  ...(reduction[ref.area.parentId] || {}),
                                  areaId: ref.area.id,
                                  refinement: ref.refinement,
                              },
                          },
                {},
            );
        default:
            return areaRefinements.map(ref => ({
                areaId: ref.area.id,
                refinement: ref.refinement,
                note: ref.note,
            }));
    }
};
